const BUFFER_SIZE = 4096;

export default function recordAudio() {
  return new Promise((resolve, reject) => {
    // create the MediaStreamAudioSourceNode
    const AudioContext = window.webkitAudioContext || window.AudioContext;

    if (!AudioContext) {
      return reject(new Error('Browser not supported.'));
    }

    const context = new AudioContext();
    let source = null;
    let node = null;
    const arrayBuffer = [];

    navigator.getUserMedia = (navigator.getUserMedia ||
                              navigator.mozGetUserMedia ||
                              navigator.msGetUserMedia ||
                              navigator.webkitGetUserMedia);


    if (navigator.getUserMedia) {
      const constraints = { audio: true };

      navigator.getUserMedia(constraints, (stream) => {
        source = context.createMediaStreamSource(stream);
        // create a ScriptProcessorNode
        if (!context.createScriptProcessor) {
          node = context.createJavaScriptNode(BUFFER_SIZE, 1, 1);
        } else {
          node = context.createScriptProcessor(BUFFER_SIZE, 1, 1);
        }

        // listen to the audio data, and record into the buffer
        node.onaudioprocess = (e) => {
          const channel = e.inputBuffer.getChannelData(0);
          const buffer = new Float32Array(BUFFER_SIZE);
          for (let i = 0; i < BUFFER_SIZE; i++) {
            buffer[i] = channel[i];
          }

          arrayBuffer.push(buffer);
        };

        // connect the ScriptProcessorNode with the input audio
        source.connect(node);
        node.connect(context.destination);
      }, (e) => reject(e));
    } else {
      return false;
    }

    return setTimeout(() => {
      node.disconnect();
      resolve(arrayBuffer);
    }, 4000);
  });
}



// WEBPACK FOOTER //
// ./libs/record.js